// =============================================================================
// cardGradient — 게임사 카드 그라데이션 '게임사별 고정 랜덤색' 도달 유틸 (2026-06-11 Phase 5)
// =============================================================================
//
// WHY: 슬롯/카지노 그라데이션이 random_enabled 이면, 각 게임사 카드(.provider-item)는 관리자 팔레트에서
//   providerCode 해시로 결정된 '고정 색'을 받아야 한다(같은 게임사 = 항상 같은 색 = 깜빡임 없음).
//   렌더 지점(ProviderGrid ×4, 디자인1 SlotPage/CasinoPage)이 이 유틸로 색을 구해 카드 div 에 인라인
//   --card-grad-color 로 주입하면, App.css 의 완성 그라데이션 문자열 내 var(--card-grad-color, …) 가 받는다.
//
// 무손상: 랜덤 미설정(random_enabled !== true) 또는 유효 팔레트 0개면 null 반환 → 인라인 변수 미주입 →
//   완성 문자열의 var() fallback(치환된 스톱의 원본색)이 그대로 적용된다(랜덤 안 켜면 완성 문자열에 var 자체가 없음).
//   var 치환 위치(transparent 가 아닌 '마지막 색 스톱')는 hook(useDomainTheme.buildGradient)이 결정 — 이 유틸은 색 결정만 담당.
//
// 기존 게임카드 랜덤(getRandomGradient·--random-gradient, gameUtils.js, 게임 팝업용)과는 완전 별개·무관.
// =============================================================================
import { getActiveDesignTokens } from '../hooks/useDomainTheme';

// rgba/hex/hsl/named 색 형식 검증(중대3: 팔레트 각 색 정규식 게이트). hook/부트스트랩과 동일 정규식.
const GRAD_COLOR_RE = /^(#[0-9a-fA-F]{3,8}|(rgb|rgba|hsl|hsla)\([0-9.,%\s/]+\)|[a-zA-Z]+)$/;

// 결정적(deterministic) 문자열 해시 — 같은 providerCode 는 항상 같은 정수. djb2 변형.
const hashCode = (str) => {
  let h = 5381;
  const s = String(str || '');
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

// type('slot'|'casino') + providerCode → 카드별 고정 랜덤색(문자열) 또는 null(랜덤 미적용).
export const resolveCardGradColor = (type, providerCode) => {
  const tokens = getActiveDesignTokens();
  const gradient = tokens && typeof tokens.gradient === 'object' ? tokens.gradient : null;
  const conf = gradient ? gradient[type] : null;
  if (!conf || typeof conf !== 'object' || conf.random_enabled !== true) return null;
  const palette = Array.isArray(conf.random_palette)
    ? conf.random_palette.filter((c) => {
        const s = (c === null || c === undefined) ? '' : String(c).trim();
        return !!s && GRAD_COLOR_RE.test(s);
      })
    : [];
  if (palette.length === 0) return null;
  const idx = hashCode(providerCode) % palette.length;
  return String(palette[idx]).trim();
};
